// extracted by mini-css-extract-plugin
export var spacing = "Blog-module--spacing--3afzG";